import { render, staticRenderFns } from "./ActivityFilters.vue?vue&type=template&id=20a797c2&scoped=true"
import script from "./ActivityFilters.vue?vue&type=script&lang=js"
export * from "./ActivityFilters.vue?vue&type=script&lang=js"
import style0 from "./ActivityFilters.vue?vue&type=style&index=0&id=20a797c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a797c2",
  null
  
)

export default component.exports